
module.config(function($stateProvider) {

    $stateProvider.state('settings.states', {
        url: '/states',
        templateUrl: 'settings/usStates',
        permission: 'editStates',
        resolve: {
            stateUrl: function(ApiUrl) {
                return ApiUrl.partial('state');
            },
            states: function($http, stateUrl) {
                return $http.get(stateUrl()).then(getResponseItems);
            },
            regions: function($http, ApiUrl) {
                return $http.get(ApiUrl('dol_region')).then(getResponseItems);
            },
        },
        controller: module.cC({
            inject: ['$scope', '$http', 'states', 'stateUrl', 'regions'],
            data: {states: 'states', regions: 'regions'},
            init: function() {
                this.updateDistrictTotal();
            },
            methods: {
                updateDistrictTotal: function() {
                    this.$.districtTotal = 0;
                    for (var i = 0; i < this.$.states.length; i++) {
                        this.$.districtTotal += (this.$.states[i].district_count || 0);
                    }
                },
                edit: function(state) {
                    state.formData = {
                        dol_region_number: state.dol_region_number || "",
                        minimum_wage: state.minimum_wage,
                        district_count: state.district_count,
                    };
                    state.editing = true;
                },
                cancel: function(state) {
                    delete state.formData;
                    delete state.editing;
                    this.updateDistrictTotal();
                },

                save: function(form, state) {
                    if (form.$invalid) return;
                    var url = this.stateUrl(state.abbreviation);
                    return this.$http.patch(url, state.formData).then(function(r) {
                        angular.extend(state, r.data.item);
                        return state;
                    });
                }
            }
        }),
    });
});


function getResponseItems(response) {
    return response.data.items;
}